import React from 'react'
import useEvents from 'pages/Cms/event-list/use-events'
import EventsList from '../events-list'
import { Panel } from './styles'
import type { EventListPanelProps } from './types'

const EventsListPanel: React.FC<EventListPanelProps> = ({ ownerId, eventTimeline, name }) => {
  const { groupedEvents, hasMoreElements, loadMore, loading } = useEvents({
    ownerId,
    eventTimelineFilter: eventTimeline,
  })

  return (
    <Panel key={name} value={name}>
      <EventsList
        groupedEvents={groupedEvents}
        hasMoreElements={hasMoreElements}
        loadMore={loadMore}
        isLoading={loading}
      />
    </Panel>
  )
}

export default EventsListPanel
